import { IconBadgeProps } from './types'
import { colors } from '@ui/colors'

// export const badgeEnabled = {
//   name: 'check',
//   size: 14,
//   strokeWidth: 4,
//   color: colors.lime[500],
// } satisfies IconBadgeProps['badge']

// export const badgeDisabled = {
//   name: 'x',
//   size: 14,
//   strokeWidth: 4,
//   color: colors.red[500],
// } satisfies IconBadgeProps['badge']

export const badgeEnabled = {
  name: 'check',
  size: 10,
  strokeWidth: 4,
  color: colors.lime[600],
  classNameBadge: 'bg-lime-200 rounded-full w-4 h-4',
} satisfies IconBadgeProps['badge']

export const badgeDisabled = {
  name: 'x',
  size: 10,
  strokeWidth: 4,
  color: colors.red[500],
  classNameBadge: 'bg-red-100 rounded-full w-4 h-4',
} satisfies IconBadgeProps['badge']

export const sIconContainer = 'h-8 w-8 items-center justify-center rounded-full'
